import styled, { css } from 'react-emotion';

import { queries } from './mediaQueries';
import theme from './theme';

const button = css`
	cursor: pointer;
	padding: 5px;
	margin: 5px;
	text-align: center;
	border-radius: 4px;
	transition: all 0.3s cubic-bezier(.25,.8,.25,1);
`;

export const ToggleButton = styled.div`
	${button};
	color: white;
	border: 1px solid white;
	display: none;
	max-width: 200px;
	font-size: 1.3rem;
	align-self: center;
	padding: 10px;
	margin-top: 60px;

	&:hover {
		background: white;
		color: ${theme.colors.secondaryColor};
	}

	${queries.xLarge`
		margin-top:20px;
		display: block;
	`};
	
	${queries.medium`
		margin-top:60px;
		display: block;
	`};
`;

export const Button = styled.div`
	${button};
	background: ${theme.colors.lightGray};
	min-width: 70px;

	svg {
		margin-right: 4px;
	}

	&:hover {
		background: ${theme.colors.primaryColor};
		color: white;
		box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
	}
`;

export default Button;



// WEBPACK FOOTER //
// ./src/styles/Button.js